import React from 'react';
import SettingsManagement from '../components/settings/SettingsManagement';

const SettingsPage = () => {
  return <SettingsManagement />;
};

export default SettingsPage;
